/**
 * Created by sagardesai on 20/06/18.
 */
import * as types from "../actions/types/index";
import {setInitialState} from "../util/utility";

const INITIAL_STATE = setInitialState({
    notificationDataList: null
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.NOTIFICATION_LIST_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.NOTIFICATION_LIST_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                notificationDataList: action.payload
            };
        case types.NOTIFICATION_LIST_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                notificationDataList: action.payload.error,
            };
        case types.NOTIFICATION_LIST_RESET:
            return {
                ...state,
                notificationDataList: action.payload,
            };

        default:
            return {
                ...state
            }
    }
}